import React, { useState } from 'react'
import Miners from './Miners'
import Header from './Header'
import Block from './Block/Block'

export default function Home() {
  return (
    <div className='w-screen h-auto'>
      <Header></Header>
    </div>
  )
}
